<template>
  <el-card style="max-width: 48em;">
    <el-table
      v-loading="loading"
      :height="windowHeight - 240"
      style="width: 100%; height: 100%;"
      :data="events"
      :default-sort="{prop:'date', order: 'descending'}"
      @row-click="showEvent"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        label="Date"
        :fixed="$mq == 'xs' || $mq == 'sm' ? false : 'left'"
        sortable
        min-width="220"
        max-width="250"
        prop="date"
      ></el-table-column>
      <el-table-column label="Name" prop="name" min-width="120" max-width="200"></el-table-column>
      <el-table-column
        prop="term"
        min-width="120"
        :filters="termFilters"
        :filter-method="termFilter"
        filter-placement="bottom-end"
        label="Term"
      >
        <template v-if="terms != null" slot-scope="scope">
          <span>{{ cTerm(scope.row.term).name }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="bottom clearfix">
      <el-button-group class="button">
        <el-popover
          v-if="selectedEvents.length != 0 && $store.getters.hasPermission(['Records'])"
          v-model="delVisible"
          placement="top"
          width="160"
        >
          <p>Are you sure?</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="delVisible=false">No</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="selectedEvents.forEach((event) => {deleteEvent(event);})"
            >Yes</el-button>
          </div>
          <el-button
            slot="reference"
            @click="delVisible=false"
            icon="el-icon-delete"
            type="danger"
            size="small"
          ></el-button>
        </el-popover>
        <el-button
          :disabled="loading"
          v-if="$store.getters.hasPermission(['Records'])"
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openEditDialog"
        />
        <el-button
          :disabled="loading"
          v-if="$store.getters.hasPermission(['Records'])"
          type="info"
          size="small"
          icon="el-icon-s-data"
          @click="openChart"
        />
      </el-button-group>
    </div>
    <el-dialog
      title="Attendance Table"
      :fullscreen="true"
      :visible.sync="dialogTableVisible"
    >
      <nxs-attendance-table :eventTypeId="eventTypeId" />
    </el-dialog>
    <nxs-event-edit ref="editDialog" v-model="tempEvent" @save="addEvent" />
  </el-card>
</template>

<style scoped>
.button {
  margin: 4px;
  margin-right: 8px;
  margin-bottom: 0px;
  padding: 8px;
  padding-bottom: 0px;
  float: right;
}
.bottom {
  line-height: 12px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>

<script>
import {mapFields} from "vuex-map-fields";
import nxsAttendanceTable from "./AttendanceChart.vue";
import nxsEventEdit from "./EventEdit.vue";

export default {
    props: ["eventTypeId"],
    components: {
        nxsAttendanceTable,
        nxsEventEdit
    },
    data() {
        return {
            loading: true,
            selectedEvents: [],
            events: [],
            backupData: [],
            objectives: [],
            objectiveLinks: [],
            attendanceTypes: [],
            dialogTableVisible: false,
            tempEvent: {
                name: "",
                date: null,
                term: null,
                event_type: this.eventTypeId
            },
            datePickerOptions: {
                shortcuts: [
                    {
                        text: "Today",
                        onClick(picker) {
                            picker.$emit("pick", new Date());
                        }
                    },
                    {
                        text: "Yesterday",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit("pick", date);
                        }
                    },
                    {
                        text: "Tomorrow",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24);
                            picker.$emit("pick", date);
                        }
                    }
                ]
            }
        };
    },
    watch: {
        eventTypeId(val) {
            this.getEvents();
            this.tempEvent.event_type = val;
        },
        selectedTerms() {
            this.getEvents();
        }
    },
    created() {
        if (!this.$store.getters.hasPermission(["EventScanning", "Records"]))
            this.$router.push("/admin");
    },
    computed: {
        ...mapFields(["user", "terms", "selectedTerms"]),
        termFilters() {
            var t = [];
            if (this.terms == null) return t;
            this.terms.forEach((term) => {
                t.push({text: term.name, value: term.term});
            });
            return t;
        }
    },
    mounted() {
        this.getEvents();
    },
    methods: {
        openChart() {
            this.dialogTableVisible = true;
        },
        closeChart() {
            this.dialogTableVisible = false;
        },
        handleSelectionChange(val) {
            this.$set(this, "selectedEvents", val);
        },
        cTerm(id) {
            if (id.name) return {name: id.name};
            var rterm = this.terms.find((term) => {
                return term.term == id;
            });
            if (!rterm) {
                return {name: "N/A"};
            }
            return rterm;
        },
        termFilter(value, row) {
            return row.term === value;
        },
        getEvents() {
            if (this.selectedTerms == null || this.selectedTerms.length <= 0) return;
            this.loading = true;
            this.axios
                .get("/api/v1/events", {
                    params: {
                        type: this.eventTypeId,
                        terms: this.selectedTerms
                    },
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.events = response.data;
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err,
                        type: "error"
                    });
                });
        },
        showEvent(event) {
            this.$router.push("/admin/event/" + event.o_id);
        },
        openEditDialog() {
            this.$refs.editDialog.open();
        },
        addEvent(event) {
            this.events.push(event);
        },
        deleteEvent(row) {
            row.delVisible = false;
            this.axios
                .delete("/api/v1/events/" + row.o_id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: "Event deleted successfuly",
                        type: "success"
                    });
                    var temp = this.events.find((objv) => objv.o_id == row.o_id);
                    var index = this.events.indexOf(temp);
                    this.events.splice(index, 1);
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors.title,
                        type: "error"
                    });
                });
        }
    }
};
</script>
